import React from "react";
import { Link } from "react-router-dom";
import { policyGroups } from "../config/policyNavigation";
import { STORE } from "../config/store";
import "../css/policy.scss";

export default function PolicyIndex() {
  return (
    <main className="policy-page policy-index">
      <nav className="policy-breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link><span aria-hidden="true">/</span><span>Policies</span>
      </nav>
      <article className="policy-card">
        <p className="policy-kicker">{STORE.brand} · {STORE.operatingRegion}</p>
        <h1>Policies</h1>
        <p className="policy-intro">Order, product, privacy and support rules written for the physical goods and purchase path on this storefront.</p>
        <div className="policy-index-grid">
          {policyGroups.map((group) => (
            <section key={group.label}>
              <h2>{group.label}</h2>
              <ul>{group.links.map(([label, to]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
            </section>
          ))}
        </div>
        <p className="policy-contact">Questions or requests: <a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a></p>
      </article>
    </main>
  );
}
